// components/HelpSupport/UpdateSupportTicketModal.js
import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Textarea, Spinner } from "reactstrap";

const UpdateSupportTicketModal = ({ isOpen, toggle, ticket, onUpdate }) => {
  const [responsestatus, setResponsestatus] = useState(false);
  const [responseNotes, setResponseNotes] = useState("");
  const [supportType, setSupportType] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const supportTypes = [
    "Ambulance Order Issue",
    "Ambulance Other Reason",
    "Medicine Issue",
    "Delivery Issue",
    "Payment Issue",
    "Account Issue",
    "Technical Issue",
    "Other"
  ];

  useEffect(() => {
    if (ticket) {
      setResponsestatus(ticket.responsestatus || false);
      setSupportType(ticket.supporttype || "");
      setResponseNotes("");
    }
  }, [ticket]);

  const handleSubmit = async () => {
    setLoading(true);
    setError("");

    try {
      const updateData = {
        responsestatus: responsestatus,
        supporttype: supportType,
        ...(responseNotes && { responseNotes: responseNotes })
      };

      await onUpdate(updateData);
      toggle();
    } catch (error) {
      setError("Failed to update support");
      console.error("Failed to update support:", error);
    } finally {
      setLoading(false);
    }
  };

  if (!ticket) return null;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        Update Support
      </ModalHeader>
      <ModalBody>
        {/* <div className="mb-3">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <h6 className="mb-1">{ticket.name || "Anonymous User"}</h6>
              <small className="text-muted d-block">
                <i className="fas fa-phone me-1"></i>{ticket.phonenumber || "N/A"}
              </small>
              {ticket.userid && (
                <small className="text-muted d-block">
                  <i className="fas fa-user me-1"></i>User ID: {ticket.userid}
                </small>
              )}
            </div>
            <div className="text-end">
              <div className="mb-1">
                <small className="text-muted d-block">Submitted</small>
                <small>{new Date(ticket.datetime).toLocaleDateString()}</small>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="mb-3">
          <Label className="fw-semibold">Original Message</Label>
          <div className="p-3 border rounded bg-light">
            {ticket.message || "No message provided"}
          </div>
        </div> */}

        {/* <FormGroup>
          <Label for="supporttype">Support Type</Label>
          <select
            className="form-select"
            id="supporttype"
            value={supportType}
            onChange={(e) => setSupportType(e.target.value)}
          >
            <option value="">Select Support Type</option>
            {supportTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </FormGroup> */}

        <FormGroup>
          <Label for="responsestatus">Response Status</Label>
          <select
            className="form-select"
            id="responsestatus"
            value={responsestatus}
            onChange={(e) => setResponsestatus(e.target.value === "true")}
          >
            <option value="false">Pending</option>
            <option value="true">Resolved</option>
          </select>
        </FormGroup>

        {/* <FormGroup>
          <Label for="responseNotes">Response Notes (Optional)</Label>
         

          <textarea
            id="responseNotes"
            className="form-control"
            value={responseNotes}
            onChange={(e) => setResponseNotes(e.target.value)}
            rows="3"
            placeholder="Add internal notes about this support ticket..."
          />

        </FormGroup> */}

        {error && (
          <div className="alert alert-danger mt-3">
            <i className="fas fa-exclamation-circle me-2"></i>
            {error}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={handleSubmit}
          disabled={loading || !supportType}
        >
          {loading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Updating...
            </>
          ) : "Update"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default UpdateSupportTicketModal;